// extracted by mini-css-extract-plugin
module.exports = {"bq_input":"Input_bq_input__36TEQ"};